import { ObjectUtil } from "@mcleod/core";
import { MenuActionSlideout } from "../MenuActionSlideout";
import { MenuEditorTreeNode } from "../MenuEditorTreeNode";
import { MenuEditorUtil } from "../MenuEditorUtil";
import { EditMenuItemResult, MenuItemEditor } from "../MenuItemEditor";
import { MenuAction } from "./MenuAction";

export class MenuActionEdit extends MenuAction {

    override async internalExecute(): Promise<boolean> {
        const nodesToUpdate = this.getNodesMatchingThisMenuItem();
        const result = await this.showEditSlideout(nodesToUpdate);

        if (!result?.hasChanged) {
            return false;
        }

        for (const node of nodesToUpdate) {
            const updatedValues = ObjectUtil.deepCopy(result.menuItem.itemData.data);
            node.menuItem.update(updatedValues);
        }

        this.menuItemToSelect = this.node.menuItem;
        return true;
    }

    private async showEditSlideout(nodesToUpdate: MenuEditorTreeNode[]): Promise<EditMenuItemResult> {
        const menuItem = nodesToUpdate[0].menuItem;
        let layout: MenuItemEditor;

        const userSaved = await MenuActionSlideout.showMenuItemEditorSlideout({
            title: this.getActionTitle("Edit Item"),
            doAfterSlideIn: (decorator) => {
                layout = decorator.layout as MenuItemEditor;
                layout.configureForUpdateMode(menuItem);
                MenuEditorUtil.addReferencePanel({text: "Changes to this item will affect", fontBold: true}, nodesToUpdate, layout);
            }
        });
        return userSaved ? layout.getEditMenuItemResult() : null;
    }
}
